/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TaskFormalCriteriaConfig } from './taskFormalCriteriaConfig';

export type TaskEvaluationConfigOutputFormalCriteria = TaskFormalCriteriaConfig | null;
